import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';

export abstract class ICacheApi {
  abstract get(key: string): Promise<AxiosResponse<Result<string>>>;
  abstract save(
    key: string,
    serializedData: string
  ): Promise<AxiosResponse<Result<string>>>;
}

